import { v4 as uuidv4 } from 'uuid';
import { detect } from 'detect-browser';

const getOSVersion = (userAgent, os) => {
  let osVersion = 'unknown';
  if (os === 'Windows') {
    const match = userAgent.match(/Windows NT ([0-9.]+)/);
    if (match) osVersion = match[1];
  } else if (os === 'Mac OS') {
    const match = userAgent.match(/Mac OS X ([0-9_]+)/);
    if (match) osVersion = match[1].replace(/_/g, '.');
  } else if (os === 'iOS') {
    const match = userAgent.match(/OS ([0-9_]+) like Mac OS X/);
    if (match) osVersion = match[1].replace(/_/g, '.');
  } else if (os === 'Android') {
    const match = userAgent.match(/Android ([0-9.]+)/);
    if (match) osVersion = match[1];
  }
  return osVersion;
};

const getDeviceInfo = async () => {
  const browser = detect();
  const userAgent = navigator.userAgent;

  const device_type = browser ? browser.name : 'unknown';
  const make = navigator.vendor || 'unknown';
  const model = browser ? browser.name : 'unknown';
  const os = browser ? browser.os : 'unknown';
  const os_version = getOSVersion(userAgent, os);
  const ip = localStorage.getItem('ip_address');

  // Retrieve or generate unique device ID
  let device_id = localStorage.getItem('device_id');
  if (!device_id) {
    device_id = uuidv4();
    localStorage.setItem('device_id', device_id);
  }

  // Retrieve geolocation
  const getPosition = () => {
    return new Promise((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(resolve, reject);
    });
  };

  let location = { latitude: 'unknown', longitude: 'unknown', timestamp: 'unknown' };
  try {
    const position = await getPosition();
    location = {
      latitude: position.coords.latitude,
      longitude: position.coords.longitude,
      timestamp: new Date(position.timestamp).toISOString(),
    };
  } catch (error) {
    console.error('Geolocation not available or permission denied:', error);
  }

  return {
    device_id,
    device_type,
    make,
    model,
    os,
    os_version,
    ip,
    location,
  };
};

export { getDeviceInfo };
